export default __webpack_public_path__ + "static/media/algo.ea022ece.jpeg";